import "./Cards.css"
import CardTotalLicenciados from "./CardTotalLicencados";
import CardUsuariosAtivos from "./CardUsuariosAtivos";
import CardsPedidosSaques from "./CardPedidosSaques";

const CardsAdminUsuarios = (props) => {
    return(
      <section className="summary-grid">

        <CardTotalLicenciados
          total={props.total}
          title={props.totalTitle}
          subtitle={props.totalSubtitle}
        />
        
        <CardUsuariosAtivos
          ativos={props.ativos}
          inativos={props.inativos}
          subtitle={props.statusSubtitle}
        />

        <CardsPedidosSaques />

      </section>
    );
};

export default CardsAdminUsuarios;
